var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-breadcrumbs',{attrs:{"items":_vm.items,"large":""},scopedSlots:_vm._u([{key:"divider",fn:function(){return [_c('v-icon',[_vm._v(_vm._s(_vm.mdiChevronRight))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }